import { usePreloginContext } from "../../context/PreloginContext";

export default function Build() {
  const {
    build,
  } = usePreloginContext();

  return (
    <>
      { build }.{ process.env.REACT_APP_VERSION?.replaceAll('.', '') }
    </>
  );
}
